import { createFileRoute } from '@tanstack/react-router';
import { GestaoEmpresasPage } from '@/components/gestao-empresas';

export const Route = createFileRoute('/_app/configuracoes/empresas')({
  component: GestaoEmpresasPage,
});
